import React from 'react';
import styles from "./plans.module.scss";
import classNames from "classnames";

let cx = classNames.bind(styles);

const Plans = (props) => (
    <div id="plans" className={styles.clearPlans}>
        <div className={styles.clearPlansHeading}>Clear, transparent pricing</div>
        <div className={styles.clearPlansSubHeading}>Select your plan and save.</div>
    
        <div className={styles.cards}>
            <div className={styles.cardStart}>
                <div className={styles.cardLine}>Price (per month)</div>
                <div className={styles.cardLine}>Pages per month</div>
                <div className={styles.cardLine}>Additional pages</div>
                <div className={styles.cardLine}>Rollover per month</div>
                <div className={styles.cardLine}>Free Shipping &amp; Recycling</div>
            </div>
            <div className={styles.cardFree}>
                <div className={cx(styles.cardLine, styles.header)}>Free</div>
                <div className={styles.cardLine}>15 pages</div>
                <div className={cx(styles.cardLine, styles.small)}>10 pages for $1</div>
                <div className={cx(styles.cardLine, styles.minusLine)}><div className={styles.minus}></div></div>
                <div className={cx(styles.cardLine, styles.lastChild)}><div className={styles.checkmark}></div></div>
                <div className={styles.cardBtn}>
                    <a href="https://instantink.hpconnected.com/r/rebrand_printer_choice/new?jumpID=va_nxc3gze76w" className={cx(styles.btn, styles.btnOutline)}>Sign Up Now</a>
                </div>
            </div>
            <div className={styles.cardOccasional}>
                <div className={cx(styles.cardLine, styles.header)}>$2.99</div>
                <div className={cx(styles.cardLine, styles.strong)}>50 pages</div>
                <div className={cx(styles.cardLine, styles.small)}>15 pages for $1</div>
                <div className={cx(styles.cardLine, styles.smaller)}>Up to 50 unused pages <sup onClick={(evt) => { document.getElementById('footnote-8').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"}); }}>8</sup></div>
                <div className={cx(styles.cardLine, styles.lastChild)}><div className={styles.checkmark}></div></div>
                <div className={styles.cardBtn}>
                    <a href="https://instantink.hpconnected.com/r/rebrand_printer_choice/new?jumpID=va_nxc3gze76w" className={cx(styles.btn, styles.btnOutline)}>Try free for 1 month</a>
                </div>
            </div>
            <div className={styles.cardOften}>
                <div className={cx(styles.cardLine, styles.header)}>$4.99</div>
                <div className={styles.cardLine}>100 pages</div>
                <div className={cx(styles.cardLine, styles.small)}>20 pages for $1</div>
                <div className={cx(styles.cardLine, styles.smaller)}>Up to 100 unused pages <sup onClick={(evt) => { document.getElementById('footnote-8').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"}); }}>8</sup></div>
                <div className={cx(styles.cardLine, styles.lastChild)}><div className={styles.checkmark}></div></div>
                <div className={styles.cardBtn}>
                    <a href="https://instantink.hpconnected.com/r/rebrand_printer_choice/new?jumpID=va_nxc3gze76w" className={cx(styles.btn, styles.btnOutline)}>Try free for 1 month</a>
                </div>
            </div>
            <div className={styles.cardBusiness}>
                <div className={cx(styles.cardLine, styles.header)}>$9.99</div>
                <div className={styles.cardLine}>300 pages</div>
                <div className={cx(styles.cardLine, styles.small)}>25 pages for $1</div>
                <div className={cx(styles.cardLine, styles.smaller)}>Up to 300 unused pages <sup onClick={(evt) => { document.getElementById('footnote-8').scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"}); }}>8</sup></div>
                <div className={cx(styles.cardLine, styles.lastChild)}><div className={styles.checkmark}></div></div>
                <div className={styles.cardBtn}>
                    <a href="https://instantink.hpconnected.com/r/rebrand_printer_choice/new?jumpID=va_nxc3gze76w" className={cx(styles.btn, styles.btnOutline)}>Try free for 1 month</a>
                </div>
            </div>
        </div>
    </div>
);

export default Plans;
